import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { ModalService } from '@avla/ui-design';
import { TokenService } from '@services';
import { Router } from '@angular/router';
import { ROUTESPATH } from '@core';

@Component({
  selector: 'app-menu-user',
  templateUrl: './menu-user.component.html',
  styleUrls: ['./menu-user.component.scss'],
})
export class MenuUserComponent implements OnInit, AfterViewInit {
  menuOpen = false;
  public role: string;
  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    if (this.menuOpen) {
      this.menuOpen = false;
    }
  }

  constructor(
    private readonly modalService: ModalService,
    private router: Router,
    private tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.role = TokenService.user?.role || '';
  }

  ngAfterViewInit(): void {
    if (TokenService.user?.changePassword == undefined) {
      setTimeout(() => {
        this.tokenService.resetToken();
        this.router.navigate([ROUTESPATH.LOGIN]);
      });
    } else if (TokenService.user?.changePassword === true) {
      setTimeout(() => {
        this.changePassword();
      });
    }
  }

  toggleMenu() {
    if (!this.menuOpen) {
      setTimeout(() => {
        this.menuOpen = true;
      }, 10);
    }
  }

  changePassword() {
    this.modalService.open('modalPassword');
  }

  logOut() {
    this.modalService.open('modal-close-session');
  }

  users() {
    this.router.navigate([ROUTESPATH.CREATE_USER]);
  }
  emailList() {
    this.router.navigate([ROUTESPATH.EMAIL_LIST]);
  }
}
